/* Local By Heart — motion (A1–A13 in website/design-tokens.md).
   Content is visible without JS; animations only run when GSAP loads and motion is allowed. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 761px)').matches;

  /* A10: "ADDED ✓" feedback on add to cart (every page, no GSAP needed) */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) {
      if (!e || e.source !== 'product-form') return;
      document.querySelectorAll('.product-form__submit span').forEach(function (span) {
        var original = span.textContent;
        span.textContent = 'Added ✓';
        setTimeout(function () { span.textContent = original; }, 1600);
      });
    });
  }

  /* Colour swatches on product cards: swap the card photo and point the card link at that colour */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.lbh-swatch');
    if (!swatch) return;
    e.preventDefault();
    var card = swatch.closest('.card-wrapper');
    if (!card) return;
    var img = card.querySelector('.card__media img');
    if (img && swatch.dataset.src) {
      img.srcset = swatch.dataset.srcset;
      img.src = swatch.dataset.src;
    }
    card.querySelectorAll('.card__heading a').forEach(function (a) { a.href = swatch.dataset.url; });
    swatch.parentElement.querySelectorAll('.lbh-swatch').forEach(function (s) {
      s.setAttribute('aria-pressed', s === swatch ? 'true' : 'false');
    });
  });

  if (reduce || !window.gsap) return;
  var gsap = window.gsap;
  if (window.ScrollTrigger) gsap.registerPlugin(window.ScrollTrigger);
  var once = { once: true, start: 'top 80%' };

  /* A1: hero on load */
  var hero = document.querySelector('.lbh-hero');
  if (hero) {
    gsap.from(hero.querySelectorAll('.lbh-hero__title span, .lbh-hero__quote, .lbh-hero .lbh-btn'), {
      y: 24, opacity: 0, duration: 0.6, ease: 'power2.out', stagger: 0.12, delay: 0.15
    });
    /* A2: hero on scroll */
    var img = hero.querySelector('.lbh-hero__media img');
    if (img) {
      gsap.fromTo(img, { scale: 1.05 }, { scale: 1, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }
    if (desktop) {
      gsap.to(hero.querySelector('.lbh-hero__content'), { y: -60, ease: 'none',
        scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }
  }

  /* A3: stamps drop into album slots */
  document.querySelectorAll('.lbh-album__slots').forEach(function (slots) {
    var items = slots.querySelectorAll('.lbh-stamp, .lbh-slot-empty');
    gsap.from(items, desktop
      ? { y: -40, rotation: -8, opacity: 0, duration: 0.6, ease: 'back.out(1.6)', stagger: 0.12, scrollTrigger: Object.assign({ trigger: slots }, once) }
      : { y: 16, opacity: 0, duration: 0.45, ease: 'power2.out', stagger: 0.1, scrollTrigger: Object.assign({ trigger: slots }, once) });
  });

  /* A3b: era tiles rise in one by one */
  document.querySelectorAll('.lbh-eras__grid').forEach(function (grid) {
    gsap.from(grid.children, { y: 32, opacity: 0, duration: 0.6, ease: 'power2.out', stagger: 0.12,
      scrollTrigger: Object.assign({ trigger: grid }, once) });
  });

  /* A5: the joke, country word swaps */
  var joke = document.querySelector('.lbh-joke');
  var word = joke && joke.querySelector('.lbh-joke__word');
  if (word) {
    var words = (word.getAttribute('data-words') || '').split(',').filter(Boolean);
    var setWord = function (i) { word.textContent = words[Math.max(0, Math.min(words.length - 1, i))]; };
    if (desktop && words.length > 1) {
      ScrollTrigger.create({ trigger: joke, start: 'top top', end: '+=' + (words.length * 60) + '%', pin: true,
        onUpdate: function (st) { setWord(Math.floor(st.progress * words.length)); } });
    } else if (words.length > 1) {
      ScrollTrigger.create({ trigger: joke, start: 'top 70%', once: true, onEnter: function () {
        words.forEach(function (w, i) { setTimeout(function () { setWord(i); }, 700 * (i + 1)); });
      } });
    }
  }

  /* A6: print close-up zoom */
  var shirtImg = document.querySelector('.lbh-shirt .lbh-split__media img');
  if (shirtImg && desktop) {
    gsap.fromTo(shirtImg, { scale: 1 }, { scale: 1.08, ease: 'none',
      scrollTrigger: { trigger: shirtImg, start: 'top bottom', end: 'bottom top', scrub: true } });
  }

  /* A7: facts one by one */
  document.querySelectorAll('.lbh-facts').forEach(function (list) {
    gsap.from(list.children, { y: 12, opacity: 0, duration: 0.4, stagger: 0.12, scrollTrigger: Object.assign({ trigger: list }, once) });
  });

  /* A8: skit stills flicker on like a CRT, PRESS START blinks twice */
  document.querySelectorAll('.lbh-still').forEach(function (still, i) {
    var tl = gsap.timeline({ scrollTrigger: Object.assign({ trigger: still }, once), delay: i * 0.15 });
    tl.from(still, { opacity: 0, filter: 'brightness(3)', duration: 0.08 })
      .to(still, { opacity: 0.3, duration: 0.05 })
      .to(still, { opacity: 1, filter: 'brightness(1)', duration: 0.25 });
    var press = still.querySelector('.lbh-still__press');
    if (press) tl.to(press, { opacity: 1, duration: 0.15, repeat: 3, yoyo: true }).set(press, { opacity: 0 });
  });

  /* A12: generic fade-up */
  document.querySelectorAll('[data-lbh-fade]').forEach(function (el) {
    gsap.from(el, { y: 12, opacity: 0, duration: 0.4, ease: 'power2.out', scrollTrigger: Object.assign({ trigger: el }, once) });
  });

  /* A13: scroll progress line (homepage, desktop) */
  var bar = document.querySelector('.lbh-progress');
  if (bar && desktop) {
    gsap.to(bar, { scaleX: 1, ease: 'none', scrollTrigger: { start: 0, end: 'max', scrub: true } });
  }
})();
